import React from 'react';
import "./ResumePage.css";
import Data from './Data';
import Card from './Card';

const ResumePage = () => {
  return (
   <section className="resume container section dark:bg-gray-800" id="resume">
    <h2 className="section__title dark:text-white">Experience</h2>
    <div className="resume__container grid">
      <div className="timeline grid">
        {Data.map((val,id)=>{
          if(val.category === "education"){
            return (
              <Card key={id} 
               icon={val.icon} 
               title={val.title}
              year={val.year}
               major={val.major}
               summary={val.summary}
               />
            )
          }
        })}
      </div>

      <div className="timeline grid">
        {Data.map((val,index)=>{
          if(val.category === "experience"){
            return (
              <Card key={index} 
               icon={val.icon} 
               title={val.title}
              year={val.year} 
              desc={val.desc}/>          
              )
          }
        })}
      </div>
    </div>
   </section>
  )
}

export default ResumePage;